var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.79004,
    cy: 8,
    r: 8,
    fill: "#27AE60"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24633 11.4667C7.08633 11.4667 6.93966 11.4133 6.81965 11.2933L4.16633 8.64C3.92633 8.4 3.92633 8.02667 4.16633 7.78667C4.40633 7.54667 4.77966 7.54667 5.01965 7.78667L7.25966 10.0133L12.5797 4.70667C12.8197 4.46667 13.193 4.46667 13.433 4.70667C13.673 4.94667 13.673 5.32001 13.433 5.56001L7.68632 11.2933C7.55299 11.4133 7.40633 11.4667 7.24633 11.4667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/approved.030a1ebf4ae0d85c28271a4dd375cbbe.svg";
export { ForwardRef as ReactComponent };